import { put } from "redux-saga/effects";
import { MbcApi } from "../api";
import { constant } from "../constant";

// workers
function* getMbcDataSagaAction() {
  try {
    const res = yield MbcApi.getMbcAvailability();

    if (res?.status === 200) {
      const response = yield MbcApi.getCheckInData();

      if (response?.status === 200) {
        const payload = {
          type: constant.GET_MBC_DATA_SUCCESS,
          data: {
            mbcSubmitId: res?.data?.data?.id,
            title: res?.data?.title,
            des: res?.data?.description,
            sliderData: response?.data?.sliding_screens,
            questionData: response?.data?.questions,
            appointmentCount: response?.data?.appointment_count,
          },
        };
        yield put(payload);
      } else {
        const payload = {
          type: constant.GET_MBC_DATA_FAILED,
          availabilityErr: null,
          checkInErr: response,
        };
        yield put(payload);
      }
    } else {
      const payload = {
        type: constant.GET_MBC_DATA_FAILED,
        availabilityErr: res,
        checkInErr: null,
      };
      yield put(payload);
    }
  } catch (error) {
    const payload = {
      type: constant.GET_MBC_DATA_FAILED,
      availabilityErr: error,
      checkInErr: error,
    };
    yield put(payload);
  }
}

function* getMyJourneyGraphSagaAction() {
  try {
    const res = yield MbcApi.getMyJourneyGraph();
    if (res?.status === 200) {
      const payload = {
        type: constant.GET_MY_JOURNEY_GRAPH_SUCCESS,
        data: res?.data,
      };
      yield put(payload);
    } else {
      const payload = {
        type: constant.GET_MY_JOURNEY_GRAPH_FAILED,
        error: res,
      };
      yield put(payload);
    }
  } catch (error) {
    const payload = {
      type: constant.GET_MY_JOURNEY_GRAPH_FAILED,
      error: error,
    };
    yield put(payload);
  }
}

export { getMbcDataSagaAction, getMyJourneyGraphSagaAction };
